import React from 'react';
import Icon from '../../../components/AppIcon';

const AnalyticsDashboardPanel = ({ channelData, attributionData, dateRange }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
          <Icon name="BarChart3" className="w-5 h-5 text-blue-600" />
          Analytics Dashboard
        </h2>
        <span className="text-sm text-gray-500">{dateRange?.replace('_', ' ')}</span>
      </div>

      {/* Lead Source Performance Matrix */}
      <div className="mb-6">
        <h3 className="text-sm font-medium text-gray-700 mb-4">Lead Source Performance Matrix</h3>
        <div className="space-y-3">
          {channelData?.map((channel) => (
            <div key={channel?.id} className="border border-gray-200 rounded-lg p-4">
              <div className="flex items-center justify-between mb-2">
                <span className="font-medium text-gray-900">{channel?.channel}</span>
                <span className={`px-2 py-1 rounded text-xs font-medium ${
                  channel?.quality === 'high' ? 'bg-green-100 text-green-800' :
                  channel?.quality === 'medium'? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'
                }`}>
                  {channel?.quality} quality
                </span>
              </div>
              <div className="grid grid-cols-4 gap-4 text-sm">
                <div>
                  <p className="text-gray-500">Leads</p>
                  <p className="font-semibold text-gray-900">{channel?.leads}</p>
                </div>
                <div>
                  <p className="text-gray-500">Conversions</p>
                  <p className="font-semibold text-gray-900">{channel?.conversions}</p>
                </div>
                <div>
                  <p className="text-gray-500">Conv. Rate</p>
                  <p className="font-semibold text-gray-900">{channel?.conversionRate}%</p>
                </div>
                <div>
                  <p className="text-gray-500">ROI</p>
                  <p className="font-semibold text-green-600">{channel?.roi}%</p>
                </div>
              </div>
              {/* Visual bar */}
              <div className="mt-3 h-2 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-blue-600 rounded-full"
                  style={{ width: `${Math.min(channel?.conversionRate * 3, 100)}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Conversion Funnel Analysis */}
      <div>
        <h3 className="text-sm font-medium text-gray-700 mb-4">Conversion Funnel Analysis</h3>
        <div className="space-y-2">
          {attributionData?.map((touchpoint, index) => (
            <div key={touchpoint?.id} className="relative">
              <div className="flex items-center gap-4">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-medium">
                  {index + 1}
                </div>
                <div className="flex-1 bg-gray-50 rounded-lg p-3">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-medium text-gray-900">{touchpoint?.touchpoint}</p>
                      <p className="text-sm text-gray-500">{touchpoint?.channel}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-lg font-bold text-blue-600">{touchpoint?.credit}%</p>
                      <p className="text-xs text-gray-500">credit</p>
                    </div>
                  </div>
                  <div className="mt-2 flex items-center gap-4 text-xs text-gray-600">
                    <span>{touchpoint?.interactions} interactions</span>
                    <span>•</span>
                    <span>Avg time to next: {touchpoint?.avgTimeToNext}</span>
                  </div>
                </div>
              </div>
              {index < attributionData?.length - 1 && (
                <div className="ml-4 h-4 w-0.5 bg-gray-300" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnalyticsDashboardPanel;